export enum PestKind {
  Category = "CATEGORY",
  Indicator = "INDICATOR",
}
